export default __webpack_public_path__ + "static/media/crunch-logo.98621305.jpg";